import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-nav-31",
  "use": "icon-icon-nav-31-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-nav-31\"><path d=\"M747.2 449.28a239.68 239.68 0 0 0-448-64A191.808 191.808 0 0 0 128 576c0 105.92 86.08 192 192 192h416A160 160 0 0 0 896 608c0-84.48-65.6-152.96-148.8-158.72zM576 544v128H448v-128H352L512 384l160 160H576z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/icon-nav-31.svg
// module id = jXkG
// module chunks = 3